<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Dashboard" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <h5 style="width: 100%; text-align: left;">Welcome to Empower Admin Panel!</h5>
                            <div v-if="!loading && !error">
                                <div>
                                    <p class="mt-2 main-title text-right">Content</p>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/expertise">
                                                    <div class="title">Expertise
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.expertise }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="col-md-4 margin-y-axis">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/research/list">
                                                    <div class="title">Research
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.research }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/publication/list">
                                                    <div class="title">Publication
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.publication }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                                <div class="mt-4">
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/co-production-lab">
                                                    <div class="title">CoProduction Lab
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.lab }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="col-md-4 margin-y-axis">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/advocacy/list">
                                                    <div class="title">Advocacy
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.advocacy }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <router-link to="/content/news">
                                                    <div class="title">News
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.news }}</div>
                                                </router-link>
                                            </div>
                                        </div>
                                    </div> 

                                    <p class="mt-5 main-title">About & Policy</p>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Partner</div>
                                                    <div class="count">{{ count_list.partner }}</div>
                                                    <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                                    <router-link to="/about/partner">
                                                        <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4 margin-y-axis">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Team</div>
                                                    <div class="count">{{ count_list.team }}</div>
                                                    <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                                    <router-link to="/about/team">
                                                        <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Policy</div>
                                                    <div class="count">{{ count_list.policy }}</div>
                                                    <div style="padding-top: 8px; border-bottom: 2px solid #1e73ed;"></div>
                                                    <router-link to="/setting/policy">
                                                        <div style="text-align: center; font-size: medium; padding-top: 8px; cursor: pointer;">View</div>
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="mt-5 main-title text-right">Career & Contact</p>
                                    <div class="d-flex flex-column flex-md-row">
                                        <div class="col-md-3">
                                            <router-link to="/career/job/list">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Job
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.job }}</div>
                                                </div>
                                            </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-3 margin-y-axis">
                                            <router-link to="/career/job/applicant">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Applicant
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.job_applications }}</div>
                                                </div>
                                            </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-3 margin-botton">
                                            <router-link to="/contact/message">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Message
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.contact }}</div>
                                                </div>
                                            </div>
                                            </router-link>
                                        </div>
                                        <div class="col-md-3">
                                            <router-link to="/contact/subscriber">
                                            <div style="background-color: #e8f1fd; color: black; padding: 16px;" class="border-class">
                                                <div>
                                                    <div class="title">Subscriber
                                                        <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                    </div>
                                                    <div class="count">{{ count_list.subscriber }}</div>
                                                </div>
                                            </div>
                                        </router-link>
                                        </div>
                                    </div>
                                </div>
                           </div>
                           <div v-else>
                                <loader />
                           </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';

    export default {
        components: {
            loader
        },
    
        computed: {
            ...mapState({
                count_list: state => state.dashboard.count,
                loading:state => state.dashboard.countLoading,
                error:state => state.dashboard.countError
            })
        },
    
        mounted() {
            this.$store.dispatch("dashboard/fetchDashboardCount")
        }
    };
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large; 
    font-weight: 500; 
    color: #1e73ed;
}

.count {
    text-align: end; 
    font-size: xx-large; 
    font-weight: 500; 
    padding-right: 28px;
}

.main-title {
    font-size: x-large; 
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large; 
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
       padding-right: 12px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
    